<mat-card>
  <mat-card-content>
    <mat-tab-group class="primary-tab-group mat-tab-content-border">
      <mat-tab label="Active" *ngIf="!isInsurerUser">
        <app-active-prior-auth-list-provider-component></app-active-prior-auth-list-provider-component>
      </mat-tab>
      <mat-tab label="My Organization's PARs" *ngIf="isInsurerUser && isWorkloadAdminUser">
        <app-active-prior-auth-list-insurer-my-org-component></app-active-prior-auth-list-insurer-my-org-component>
      </mat-tab>
      <mat-tab label="My PARs" *ngIf="isInsurerUser && isLevelReviewerUser && !isWorkloadAdminUser">
        <app-active-prior-auth-list-insurer-my-pars-component></app-active-prior-auth-list-insurer-my-pars-component>
      </mat-tab>
      <mat-tab label="My PARs" *ngIf="isInsurerUser && isLevelReviewerUser && isWorkloadAdminUser">
        <ng-template matTabContent>
          <app-active-prior-auth-list-insurer-my-pars-component></app-active-prior-auth-list-insurer-my-pars-component>
        </ng-template>
      </mat-tab>
      <mat-tab label="Resolved">
        <ng-template matTabContent>
          <app-inactive-prior-auth-list-component></app-inactive-prior-auth-list-component>
        </ng-template>
      </mat-tab>
      <mat-tab label="PAR Search" *ngIf="isInsurerUser && isWorkloadAdminUser">
        <app-prior-auth-search-component></app-prior-auth-search-component>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
